import { singleUser, editUser, editUserAvatar } from "../../../api/users/detail/index.js";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

import { Box, Button, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { PageTitle } from "../../../../../shared/ui/common/index.js";



import UserInfo from "./userInfo.jsx";
import UserSummery from "./userSummery.jsx";
import { buildAvatarForm } from "../../../api/users/detail/avatar-form";

const User = () => {
  const { token } = useSelector((state) => state.user);
  const { id } = useParams();
  const { userPermissions } = useSelector((state) => state.relationals);
  const [selectedProductImage, setselectedProductImage] = useState(null);
  const [avatar, setAvatar] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [userData, setUserData] = useState(null);

  const [access, setAccess] = useState([]);
  const [userAccess, setUserAccess] = useState();
  const [userAccessID, setUserAccessID] = useState();
  const [address, setAddress] = useState([]);
  const [province, setProvince] = useState([]);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setLoading(true);
    /*     axiosInstance(
      `${baseUrl}/${GET_ACCESS_PROFILE}?page=${1}&Limit=${1000}`,
      configReq(token)
    )
      .then((res) => {
        const { data } = res;
        var temp = data.data;
        temp.unshift({ id: -1, title: "هیچکدام" });

        setAccess(temp);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
      }); */
    singleUser(id, token)
      .then((res) => {
        const { data } = res;
        setLoading(false);
        if (data && data.code === 200 && data.data) {
          setUserData(data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
    /*     axiosInstance(
      `${baseUrl}/${GET_USER_ADDRESS}?filter[0][key]=userId&filter[0][value]=${id}&filter[0][operator]=eq`,
      configReq(token)
    )
      .then((res) => {
        const { data } = res;
        setLoading(false);
        if (data && data.code === 200 && data.data) {
          setAddress(data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response?.data?.message);
      }); */
    /*     axiosInstance(`${baseUrl}/${GET_PROVINCE}`, configReq(token))
      .then((res) => {
        const { data } = res;
        setLoading(false);
        if (data && data.code === 200 && data.data) {
          setProvince(data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response?.data?.message);
      }); */
  }, [id, token]);
  useEffect(() => {
    setUserAccess(access.find((item) => item.id === userAccessID) || false);
  }, [access, userAccessID]);

  const handleSumbit = async () => {
    if (loading || loadingButton || !userData?.id) return;
    setLoadingButton(true);
    var temp = { ...userData };
    for (var prop in temp) {
      if (temp[prop] === "") {
        delete temp[prop];
      }
    }
    try {
      const formData = buildAvatarForm({ id: userData.id, file: avatar, galleryId: selectedProductImage, currentGalleryId: userData.galleryId });
      const response = await editUser(temp, token);
      const saved = formData ? await editUserAvatar(formData, token) : response;
      if (saved.data?.data) setUserData(saved.data.data);
      setAvatar(undefined); setselectedProductImage(null);
      toast.success("با موفقیت ویرایش شد");
    } catch (err) { toast.error(err.response?.data?.message || err.message || "ذخیره اطلاعات انجام نشد."); }
    finally { setLoadingButton(false); }
  };
  /*   if (!userPermissions?.user?.update) {
    return <NoAccess />;
  } */

  return (
    <>
      <PageTitle
        title="جزییات کاربر"
        broadCrumb={[
          {
            title: "   غرفه و کاربران",
            path: "/users",
          },
          {
            title: "کاربران",
            path: "/users",
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        <div className="flex justify-between items-start">
          <div className="flex flex-col">
            <Typography
              component="div"
              className="flex items-center gap-2"
              variant="h6"
            >
              اطلاعات
              <div className="text-[#13318f] mx-1">
                {userData?.fname} {userData?.lname}
              </div>
            </Typography>
            {/*     <div className="flex items-center gap-2 mt-2">
              <div className="flex items-center gap-1">
                <Typography
                  variant="body2"
                  sx={{ color: "#8094ae !important" }}
                >
                  آیدی کاربر :
                </Typography>
                <Typography variant="body2">{id}</Typography>
              </div>
              <div className="flex items-center gap-1">
                <Typography
                  variant="body2"
                  sx={{ color: "#8094ae !important" }}
                >
                  آخرین ورود :
                </Typography>
                <Typography variant="body2">
                  <DateDisplay date={userData?.lastLogin} />
                </Typography>
              </div>
            </div> */}
          </div>
          <Link to="/users">
            <Button variant="outlined">بازگشت</Button>
          </Link>
        </div>

        <Paper sx={{ border: "1px solid #dbdfea", mt: 2 }} elevation={0}>
          <div className="grid md:grid-cols-4 grid-cols-1 ">
            <UserSummery
              userData={userData}
              avatar={avatar}
              setAvatar={setAvatar}
              /*  address={userData.galleryId} */
              selectedProductImage={selectedProductImage}
              setselectedProductImage={setselectedProductImage}
            />
            <div className="md:col-span-3 md:border-r relative">
              {userData && (
                <UserInfo
                  userData={userData}
                  setUserData={setUserData}
                  id={id}
                  access={access}
                />
              )}
              <div className="flex w-full justify-end px-5">
                <Button type="button" disabled={loading || loadingButton || !userData?.id} onClick={handleSumbit} variant="contained">
                  ثبت اطلاعات
                </Button>
              </div>
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
};

export default User;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
